<div class="modal-main-header">
  <span class="modal-title">Add New Metattach</span>
</div>
<ion-content>
  <div class="modal-content">
    <form>
      <ion-grid class="ion-no-padding">
        <ion-row class="ion-no-padding ion-no-margin">
          <ion-col size="12" class="ion-no-padding">
            <ion-label>
              Enter Name of the Metattach
            </ion-label>
            <ion-input type="text" name="name" [(ngModel)]="metattachName" placeholder="Enter Name of the Metattach"></ion-input>
          </ion-col>
        </ion-row>
        <div class="modal-btn-wrapper">
          <ion-button class="modal-back-btn" (click)="cancel()"><img src="/assets/icon/Arrow - Left 2.svg" alt="">go back</ion-button>
          <ion-button  class="modal-save-btn" [disabled]="!metattachName" (click)="addMetattach()">
            save Metattach
          </ion-button>
        </div>
      </ion-grid>
    </form>
  </div>
</ion-content>
